import React, { useState } from 'react';
import { Megaphone, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Layout from '@/components/Layout';
import AnnouncementsSection from '@/components/AnnouncementsSection';
import AddAnnouncementModal from '@/components/AddAnnouncementModal';

const AnnouncementsPage = ({ user, onLogout }) => {
  const isAdmin = user?.role === 'admin';
  const [showAddModal, setShowAddModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="p-6 lg:p-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
          <div>
            <h1 className="text-3xl font-bold tracking-tight flex items-center gap-3">
              <Megaphone className="h-8 w-8 text-primary" />
              Comunicados
            </h1>
            <p className="text-muted-foreground mt-1">
              {isAdmin ? 'Gerencie os comunicados para parceiros' : 'Acompanhe os comunicados da empresa'}
            </p>
          </div>
          {isAdmin && (
            <Button onClick={() => setShowAddModal(true)}>
              <Plus className="w-4 h-4 mr-2" />
              Novo Comunicado
            </Button>
          )}
        </div>

        {/* Announcements Section */}
        <AnnouncementsSection key={refreshKey} isAdmin={isAdmin} fullPage={true} />

        {/* Add Modal */}
        {showAddModal && (
          <AddAnnouncementModal
            onClose={() => setShowAddModal(false)}
            onSuccess={() => { setShowAddModal(false); handleRefresh(); }}
          />
        )}
      </div>
    </Layout>
  );
};

export default AnnouncementsPage;
